var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('sidebar-v2'),_c('div',{attrs:{"id":"content"}},[_c('top-toolbar'),_c('router-view'),_c('timer-access-token2',{attrs:{"refreshTokenTime":60}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }